query SearchIntegrationList(
  $integrationId: ID!,
  $listType: ListType!,
  $searchQuery: String
) {
  searchIntegrationList(
    integrationId: $integrationId,
    listType: $listType,
    searchQuery: $searchQuery
  ) {
    results {
      id
      name
      type
    }
    searchQuery
  }
}
